export const LAST_JOB_V2_FILTER_CONDITION =
  'red_admin_last_job_v2_filter_condition'
export const OPTIONAL_MENU_INFO_SHOWN = 'red_admin_optional_menu_info_shown'
export const MAIL_TOKEN_RESULT = 'red_admin_mail_token_result'
export const JOBS_PER_PAGE = 'red_admin_jobs_per_page'
